import React, { useEffect, useState } from "react";
import { checkoutStyle } from "../../../theme/theme";
import Button from "../../button/Button";
import CustomCheckbox from "../../customFormElements/customCheckbox/CustomCheckbox";
import Input from "../../input/Input";

import CountryList from "../../../assets/json/states.json";

import CustomSelect from "../../customFormElements/customSelect/CustomSelect";

const defaultSelected = {
  state: "",
  code: "",
  cities: [],
};

const PaymentMethod = (props) => {
  const {
    onSubmit,
    setAddress,
    address,
    isLoading,
    deliveryIsBilling,
    setDeliveryIsBilling,
  } = props;

  const [selectedState, setSelectedState] = useState(defaultSelected);

  useEffect(() => {
    if (address?.state && address?.city)
      CountryList.forEach((item) => {
        return item.state === address.state && setSelectedState(item);
      });
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    return onSubmit({ deliveryIsBilling });
  };

  const handleInputChange = (event) => {
    const key = event.target.name;
    const value = event.target.value;
    setAddress({ ...address, [key]: value });
  };
  const handleSelectChange = (event, key) => {
    const value = event.target.value;
    CountryList.forEach((item) => {
      return key !== "city" && item.state === value && setSelectedState(item);
    });
    key === "state"
      ? setAddress({ ...address, [key]: value, city: "" })
      : setAddress({ ...address, [key]: value });
  };

  return (
    <form
      id="payment-form"
      onSubmit={handleSubmit}
      className=" w-full desktop:w-2/5 tablet:min-w-26rem flex flex-col "
    >
      <h2 className="text-left  pl-2 , text-txtBlack">Billing Information</h2>
      <div
        className={
          checkoutStyle["containerWhite"] + "flex-row items-center gap-4 mt-10"
        }
      >
        <CustomCheckbox
          name="same-as-delivery"
          checked={deliveryIsBilling}
          onClick={() => setDeliveryIsBilling(!deliveryIsBilling)}
        />
        <p className="text-sm font-medium text-txtBlack">
          Same as delivery information
        </p>
      </div>
      {!deliveryIsBilling && (
        <div className={checkoutStyle["containerWhite"] + "flex-col  mt-10"}>
          <h3 className={"pl-2 text-left"}>Billing Address</h3>
          <Input
            classOverride
            className={checkoutStyle["textInput"]}
            type="text"
            name={"address"}
            placeholder={"Address"}
            value={address?.address}
            onChange={(e) => handleInputChange(e)}
            required={true}
          />
          <CustomSelect
            stateList={CountryList}
            value={address?.state}
            name="State"
            handleChange={(e) => handleSelectChange(e, "state")}
          />
          <div className=" flex xl:flex-row gap-4">
            <CustomSelect
              citiesList={selectedState.cities}
              value={address?.city}
              name="City"
              handleChange={(e) => handleSelectChange(e, "city")}
            />
            <div className="w-2/3">
              <Input
                classOverride
                className={checkoutStyle["textInput"]}
                name="zip"
                type="text"
                value={address?.zip}
                placeholder="Zip"
                required={true}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
          </div>
        </div>
      )}
      <div className="w-full mb-10 desktop:mb-0  mt-14 max-w-lg flex justify-center">
        <Button isLoading={isLoading} type={"submit"} title="Confirm" />
      </div>
    </form>
  );
};
export default PaymentMethod;
